import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import api from "../../api/api";
import Loader from "../../components/loader";

const UserLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");

    if (token) {
      const request = {
        url: "/prod/ext/sso/login",
        data: { token },
      };

      api
        .post2(request)
        .then((res) => {
          if (res.data?.result) {
            const { email_id, key, inst_id, phone, status, redirect_url } =
              res.data.result;

            sessionStorage.setItem("redirectUrl", redirect_url || "/");
            sessionStorage.setItem("loginViaToken", "true");

            if (status === "success") {
              dispatch({
                type: "BEGIN_LOGIN",
                user: phone || email_id,
                password: key,
                institute_id: inst_id,
                renew: false,
                dispatch,
              });

              setTimeout(() => {
                history.replace("/dashboard");
              }, 1000);
            } else {
              history.replace("/errorPage", {
                state: { redirectUrl: redirect_url || "/" },
              });
            }
          } else {
            history.replace("/errorPage", {
              state: { redirectUrl: "/" },
            });
          }
        })
        .catch(() => {
          history.replace("/errorPage", {
            state: { redirectUrl: "/" },
          });
        });
    } else {
      history.replace("/errorPage", {
        state: { redirectUrl: "/" },
      });
    }
  }, [dispatch, history]);

  return <Loader />;
};

export default UserLogin;
